module.exports = __webpack_public_path__ + "static/media/instagram.c0f18922.svg";